<div
  #dialog
  aria-labelledby="modalTitle"
  class="lang-modal-content"
  tabindex="0"
>
  <div class="bg-dark action-bar d-block d-lg-none">
    <button (click)="close()" class="float-right close" type="button">
      Close
    </button>
  </div>
  <span class="sr-only" id="modalTitle">{{ CLSTitle }}</span>
  <div class="langselct-flyout container content mt-0 p-0">
    <div class="extsite-flyout">
      <div class="mt-0 border-0">
        <div class="modal-header row border-0 p-0">
          <h4 class="title">{{ CLSTitle }}</h4>
          <button
            (click)="close()"
            class="full-list-close float-right d-none d-lg-block circle-outline"
            type="button"
          >
            <img
              alt="close"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            />
          </button>
          <div class="page-lang col-md-12 col-lg-12">
            <a
              (click)="dispalyContentLanguage()"
              *ngIf="displayButtonText && displayButtonText !== ''"
              href="javascript:void(0);"
            >
              {{ displayButtonText }}
            </a>
          </div>
        </div>
        <div class="modal-content-container">
          <div class="form-row align-items-center search-dialog m-0">
            <div
              class="col-1 col-sm-1 d-sm-none d-md-none d-lg-none ml-4 mr-1 p-0"
            >
              <span class="search m-0"></span>
            </div>
            <div class="col-7 col-lg-6 col-md-6 col-sm-12 p-0">
              <label
                [innerHtml]="
                  !isSearchFocused && searchValue?.length < 1
                    ? CLSsearchplaceholder
                    : CLSsearchLabel
                "
                [ngClass]="{
                  placeholder: !isSearchFocused && searchValue?.length < 1,
                  'd-block': searchValue?.length > 0
                }"
                class="search-label"
                for="search_input"
              ></label>
              <div [ngClass]="{ active: isSearchFocused }" class="input-group">
                <input
                  #searchField
                  (focus)="onSearchFieldFocus()"
                  (focusout)="onSearchFieldFocusout()"
                  (input)="onSearchValueChanged($event)"
                  [(ngModel)]="searchValue"
                  [ngClass]="{ 'border-bottom': searchValue?.length > 1 }"
                  aria-describedby="resultStatus"
                  aria-invalid="false"
                  autocomplete="off"
                  class="form-control mb-2 mb-sm-0 custom-search-color"
                  id="search_input"
                  placeholder=""
                  type="text"
                />
                <span class="input-group-addon p-0">
                  <button
                    (click)="clearSearchField()"
                    [ngClass]="{ 'd-none': searchValue?.length < 1 }"
                    class="btn btn-clear custom-search-icon"
                    type="button"
                  >
                    <span class="sr-only">Clear Search</span>
                  </button>
                  <button
                    (click)="focusToInput($event)"
                    class="btn btn-search d-sm-block d-md-block d-none d-lg-block circle-outline"
                    type="submit"
                  >
                    <span class="sr-only">Submit Search</span>
                  </button>
                </span>
              </div>
            </div>
            <div
              (click)="close()"
              class="col-2 col-sm-3 col-md-2 d-sm-none d-md-none d-lg-none bg-dark cancel-label"
            >
              <span class="d-block text-right text-capitalize">cancel</span>
            </div>
          </div>
        </div>
        <div class="d-sm-none d-md-block d-lg-block region-location-conatiner">
          <div class="row">
            <div
              *ngIf="!searchValue || searchValue.length === 0"
              class="region-container col-md-6 col-lg-6"
            >
              <span class="title">{{ CLSregion }}</span>
              <ul aria-label="Regions">
                <!-- mp_trans_disable_start -->
                <li
                  *ngFor="let region of regionList; index as i"
                  [ngClass]="{ active: region === selectedRegion }"
                  aria-live="assertive"
                >
                  <a
                    (click)="onRegionClicked(region, i)"
                    aria-atomic="true"
                    draggable="false"
                    href="javascript:void(0);"
                  >
                    {{ getTranslatedRegionName(region) }}
                    <span *ngIf="indexArray[i] === true" class="sr-only">
                      selected
                    </span>
                  </a>
                </li>
                <!-- mp_trans_disable_end -->
              </ul>
            </div>
            <div
              *ngIf="!searchValue || searchValue.length === 0"
              class="location-container col-md-6 col-lg-6"
            >
              <span class="title">{{ CLSlocation }}</span>
              <ul aria-label="Location & Language" id="lacation-list-container">
                <!-- mp_trans_disable_start -->
                <ng-template
                  [ngForOf]="selectedRegionCountries | sort : sortOptions"
                  let-country
                  ngFor
                >
                  <ng-template [ngIf]="country.isRegion !== 'Y'">
                    <li
                      *ngFor="
                        let language of country.languageDtls
                          | sort : sortOptionsLanguage
                      "
                    >
                      <a
                        (click)="
                          afterLanguageSelected(
                            language.languageCode,
                            country.isoCode
                          )
                        "
                        class="dropdown-itemlangugage"
                        draggable="false"
                        href="javascript:void(0);"
                      >
                        {{
                          language.countryName + ' - ' + language.languageName
                        }}
                      </a>
                    </li>
                  </ng-template>
                </ng-template>
                <ng-template
                  [ngForOf]="selectedRegionCountries | sort : sortOptions"
                  let-country
                  ngFor
                >
                  <ng-template [ngIf]="country.isRegion === 'Y'">
                    <li
                      *ngFor="
                        let language of country.languageDtls
                          | sort : sortOptionsLanguage
                      "
                    >
                      <a
                        (click)="
                          afterLanguageSelected(
                            language.languageCode,
                            country.isoCode
                          )
                        "
                        class="dropdown-itemlangugage"
                        draggable="false"
                        href="javascript:void(0);"
                      >
                        {{
                          language.countryName + ' - ' + language.languageName
                        }}
                      </a>
                    </li>
                  </ng-template>
                </ng-template>
                <!-- mp_trans_disable_end -->
              </ul>
            </div>
            <div
              *ngIf="searchValue && searchValue?.length > 0"
              class="region-container col-lg-6"
            >
              <ul class="searlist-desktop">
                <!-- mp_trans_disable_start -->
                <ng-template
                  [ngForOf]="searchList | sort : sortOptions"
                  let-country
                  ngFor
                >
                  <li *ngFor="let language of country.languageDtls">
                    <a
                      (click)="
                        afterLanguageSelected(
                          language.languageCode,
                          country.isoCode
                        )
                      "
                      draggable="false"
                      href="javascript:void(0);"
                    >
                      {{ language.countryName + ' - ' + language.languageName }}
                    </a>
                  </li>
                </ng-template>
                <!-- mp_trans_disable_end -->
              </ul>
            </div>
          </div>
        </div>
        <div class="d-lg-none d-md-none d-sm-block region-conatiner-mobile">
          <div
            *ngIf="!searchValue && searchValue?.length <= 0"
            class="mobile-region-content"
          >
            <div
              *ngFor="let region of regionList; index as i"
              [ngClass]="{ active: i === isRegionSelected }"
              class="region-content"
              dropdown
            >
              <div class="caption p-0 col-sm-12">
                <a
                  #regionView
                  (click)="onRegionClicked(region); scrollToView(regionView)"
                  aria-expanded="true"
                  draggable="false"
                  dropdownToggle
                  href="javascript:void(0);"
                  id="region{{ i }}"
                >
                  {{ getTranslatedRegionName(region) }}
                  <span class="float-right regionHedingArrow"></span>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu">
                <!-- mp_trans_disable_start -->
                <ng-template
                  [ngForOf]="selectedRegionCountries | sort : sortOptions"
                  let-country
                  ngFor
                >
                  <ng-template [ngIf]="country.isRegion !== 'Y'">
                    <li
                      *ngFor="
                        let language of country.languageDtls
                          | sort : sortOptionsLanguage
                      "
                    >
                      <a
                        (click)="
                          afterLanguageSelected(
                            language.languageCode,
                            country.isoCode
                          )
                        "
                        class="dropdown-itemlangugage"
                        draggable="false"
                        href="javascript:void(0);"
                      >
                        {{
                          language.countryName + ' - ' + language.languageName
                        }}
                      </a>
                    </li>
                  </ng-template>
                </ng-template>
                <ng-template
                  [ngForOf]="selectedRegionCountries | sort : sortOptions"
                  let-country
                  let-isFirst="first"
                  ngFor
                >
                  <ng-template [ngIf]="country.isRegion === 'Y'">
                    <li
                      *ngFor="
                        let language of country.languageDtls
                          | sort : sortOptionsLanguage
                      "
                    >
                      <a
                        (click)="
                          afterLanguageSelected(
                            language.languageCode,
                            country.isoCode
                          )
                        "
                        class="dropdown-itemlangugage"
                        href="javascript:void(0);"
                      >
                        {{
                          language.countryName + ' - ' + language.languageName
                        }}
                      </a>
                    </li>
                  </ng-template>
                </ng-template>
                <!-- mp_trans_disable_end -->
              </ul>
            </div>
          </div>
          <div
            *ngIf="searchValue && searchValue?.length > 0"
            class="region-container col-lg-6"
          >
            <div class="search-result region-content">
              <ul>
                <!-- mp_trans_disable_start -->
                <ng-template
                  [ngForOf]="searchList | sort : sortOptions"
                  let-country
                  ngFor
                >
                  <li
                    *ngFor="
                      let language of country.languageDtls
                        | sort : sortOptionsLanguage
                    "
                  >
                    <a
                      (click)="
                        afterLanguageSelected(
                          language.languageCode,
                          country.isoCode
                        )
                      "
                      class="dropdown-itemlangugage"
                      draggable="false"
                      href="javascript:void(0);"
                    >
                      {{ language.countryName + ' - ' + language.languageName }}
                    </a>
                  </li>
                </ng-template>
                <!-- mp_trans_disable_end -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
